<script lang="ts">
  import RouteGuard from './router/RouteGuard.svelte';
  import RouterView from './router/Router.svelte';
  import Toast from './shared/components/Toast.svelte';
</script>

<!-- Global toast notifications (always rendered, on top of everything) -->
<Toast />

<RouteGuard>
  <RouterView />
</RouteGuard>
